angular.module('gym.templates', ['textAngular']).config(["$stateProvider", "$provide", function($stateProvider, $provide) {
  return $stateProvider.state('gym.templates', {
    abstract: true,
    template: '<ui-view>'
  }).state('gym.templates.list', {
    url: '/templates',
    template: require('templates/gyms/communication_templates/index.html.slim')
  }).state('gym.templates.new', {
    url: '/templates/new',
    controller: 'EditTemplateCtrl',
    template: require('templates/gyms/communication_templates/new.html.slim'),
    resolve: {
      template: function() {
        return {
          channel: 'email'
        };
      }
    }
  }).state('gym.templates.edit', {
    url: '/templates/:templateId',
    controller: 'EditTemplateCtrl',
    template: require('templates/gyms/communication_templates/new.html.slim'),
    resolve: {
      template: ["Templates", "$stateParams", function(Templates, $stateParams) {
        return Templates.get($stateParams.templateId);
      }]
    }
  });
}]);
